import { z } from 'zod'

export const RECORD_VIEW_TYPES = ['LIST', 'TABLE', 'BOARD', 'CALENDAR', 'GALLERY', 'TIMELINE'] as const
export type RecordViewType = (typeof RECORD_VIEW_TYPES)[number]
export type RecordViewVisibility = 'PRIVATE' | 'SHARED'

/** Client-owned view settings, stored as-is in the view's `config` JSON. */
export interface RecordViewConfig {
  q?: string
  match?: 'ALL' | 'ANY'
  sub?: boolean
  /** Filter chips, same shape as the URL filter state. */
  filters?: unknown[]
  sort?: string
  dir?: 'ASC' | 'DESC'
  /** Table: field keys to show, in order (empty = every viewable field). */
  columns?: string[]
  /** Board: a SELECT/RADIO field key. */
  groupBy?: string
  /** Calendar and Timeline: start date field key. */
  dateField?: string
  /** Timeline: end date field key. */
  endDateField?: string
}

export const recordViewSchema = z.object({
  id: z.string().uuid(),
  recordGroupId: z.string().uuid(),
  name: z.string(),
  type: z.enum(RECORD_VIEW_TYPES),
  visibility: z.enum(['PRIVATE', 'SHARED']),
  ownerUserId: z.string().uuid(),
  config: z.record(z.unknown()).nullable().transform((c) => (c ?? {}) as RecordViewConfig),
})

export type RecordView = z.infer<typeof recordViewSchema>

export interface RecordViewRequest {
  name: string
  type: RecordViewType
  visibility: RecordViewVisibility
  config: RecordViewConfig
}

export const VIEW_TYPE_LABELS: Record<RecordViewType, string> = {
  LIST: 'List',
  TABLE: 'Table',
  BOARD: 'Board',
  CALENDAR: 'Calendar',
  GALLERY: 'Gallery',
  TIMELINE: 'Timeline',
}
